import { Component, Output, EventEmitter } from "@angular/core";
import { AutharizedEndPointService } from "@app/services/base-service/autharized-endpoint.service";
import { AuthenticationService } from "@app/services/authentication/authentication.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NgForm } from "@angular/forms";
import { ForgotPasswordService } from "@app/services/authentication/forgotPassword.service";
import { resetPassword, ApiResponse } from "@app/models/OTPResult";
import { ChangePassService } from "@app/services/authentication/change-pass.service";
import { UnlockUserService } from "@app/services/authentication/unlock-user.service";
import { HttpClient } from "@angular/common/http";
import { importExpr } from "@angular/compiler/src/output/output_ast";

@Component({
  selector: "prelogin-header",
  templateUrl: "./pre-login-header.component.html",
  styleUrls: ["./pre-login_header.scss"],
})
export class PreLoginHeaderComponent {
  @Output() onPreLoginMenuOptionClick: EventEmitter<number> =
    new EventEmitter<number>();
  //Login
  loginModals = false;
  loginModalOpen = false;
  userName: string;
  password: string;

  // Unlock user modal
  unlockModalOpen: boolean = false;
  unlock = { userName: "", mobileNumber: "", otp: "" };
  unlockErrorMessage: string = "";
  unlockOtpStep: boolean = false;

  unlockSuccessModalOpen = false;
  unlockSuccessMessage = "";
  //Forgot Password
  otpResult = new ApiResponse();
  reset: resetPassword = new resetPassword();
  errorMessageMobileNumber: string = "";
  errorMessageNumericMobileNumber: string = "";
  errorMessageOTP: string = "";
  errorMessageNumericOTP: string = "";
  hideMobileNumber: boolean = true;
  hideOtpNumber: boolean = false;
  forgotPasswordModalOpen = false;
  CustomerModalOpen = false;
  //forgotPasswordModals=false;

  //reset password

  apiModel = new ApiResponse();
  errorMessageNewPassword: string = "";
  errorMessageConfirmPassword: string = "";
  resetModalOpen = false;

  constructor(
    private toastr: ToastrService,
    private forgotPasswordService: ForgotPasswordService,
    private authenticationService: AuthenticationService,
    private changePassService: ChangePassService,
    private unlockUserService: UnlockUserService,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.otpResult.Status = false;

    window.addEventListener("scroll", function () {
      const element = document.querySelector(".inverse");
      const scrollPosition = window.scrollY;

      if (scrollPosition > 1) {
        element.classList.add("navbar-fixed-top");
      } else {
        element.classList.remove("navbar-fixed-top");
      }
    });
  }

  //LogIn
  hideModal(form: NgForm) {
    this.CustomerModalOpen = false;
    this.loginModalOpen = false;
    form.reset();
    document.body.style.overflowY = "auto";
    // window.location.reload();
  }

  login() {
    this.authenticationService.login(this.userName, this.password).subscribe(
      (data) => {
        const tempdata = JSON.parse(JSON.stringify(data));
        // debugger;
        if (tempdata.IsRedirect) {
          this.toastr.success("You have successfully logged in", "Login", {
            timeOut: 2000,
          });
          //window.location.href="http://localhost:2115/IGLPreLogin.aspx/Login";
          var el = document.createElement("form");
          var htmlHead = document.createElement("meta");
          //htmlHead.charset="utf-8";
          el.setAttribute("method", "post");
          el.setAttribute("action", tempdata.RedirectUrl);
          el.setAttribute(
            "enctype",
            "application/x-www-form-urlencoded;charset= utf-8"
          );
          var user = document.createElement("input");
          user.value = this.userName;
          user.name = "txtUserName";
          var password = document.createElement("input");
          password.type = "password";
          password.value = this.password;
          password.name = "txtPassword";
          var __EVENTTARGET = document.createElement("input");
          __EVENTTARGET.type = "hidden";
          __EVENTTARGET.value = "lnkSubmit";

          __EVENTTARGET.name = "__EVENTTARGET";

          el.appendChild(user);
          el.appendChild(password);
          el.appendChild(__EVENTTARGET);
          el.style.display = "none";
          document.head.appendChild(htmlHead);
          document.body.appendChild(el);
          el.submit();
        } else {
          localStorage.setItem("currentUser", JSON.stringify(tempdata));
          localStorage.setItem(
            "ChangePasswordValidation",
            JSON.stringify(tempdata.ChangePassword)
          );
          const currentUser = AutharizedEndPointService.UserInfo;
          localStorage.setItem("userName", this.userName);
          localStorage.setItem("id", currentUser.EmailAddress);
          localStorage.setItem("Category", currentUser.CategoryTypeId);
          localStorage.setItem("SubCategory", currentUser.SubCategoryTypeId);
          localStorage.setItem("EntityType", currentUser.EntityTypeId);
          localStorage.setItem("EntityId", currentUser.EntityId);
          localStorage.setItem("AcquirerId", currentUser.AcquirerId);
          this.toastr.success("You have successfully logged in", "Login", {
            timeOut: 2000,
          });
          // debugger;
          if (currentUser.EntityTypeId == "102")
            this.router.navigate(["/merchant"]);
          else if (currentUser.EntityTypeId == "115")
            this.router.navigate(["/secure"]);
          else this.router.navigate(["/profile/customer/account-info"]);
          //  this.router.navigate(['/profile/dashboard']);
        }
      },
      (error) => {
        if (error.error.error === "invalid_grant") {
          this.toastr.warning(error.error.error_description, "");
        } else {
          this.toastr.error(
            "There is some issue. Please try later.!",
            "Login!"
          );
        }
      }
    );
  }
  redirectToHomePage() {
    this.router.navigate(["pre-login"]);
  }
  loginModal(ev: UIEvent) {
    this.CustomerModalOpen = true;
    this.loginModalOpen = true;
    ev.stopPropagation();
    document.body.style.overflowY = "hidden";
  }
  home() {
    this.router.navigate(["/pre-login"]);
  }

  //forgot Password
  forgotPasswordModal() {
    this.forgotPasswordModalOpen = true;
    this.loginModalOpen = false;
  }

  hideForgotPasswordModal() {
    this.forgotPasswordModalOpen = false;
  }

  getOTP(reset) {
    this.errorMessageMobileNumber = "";

    let emailPattern = this.reset.mobileNumber;
    const pattern = /^\S/;
    if (!pattern.test(emailPattern)) {
      this.errorMessageMobileNumber = "Please enter valid User Name.";
      return;
    }
    if (
      this.reset.mobileNumber != null &&
      this.reset.mobileNumber != undefined &&
      this.reset.mobileNumber != ""
    ) {
      this.forgotPasswordService.getOTP(reset).subscribe(
        (data) => {
          this.otpResult = JSON.parse(JSON.stringify(data));
          if (this.otpResult != undefined && this.otpResult.Status != false) {
            this.toastr.success(this.otpResult.SuccessMessage, "OTP");
            this.errorMessageMobileNumber = "";
            this.hideMobileNumber = false;
            this.hideOtpNumber = true;
            this.errorMessageNumericMobileNumber = "";
          } else {
            this.toastr.error(this.otpResult.ErrorMessage, "OTP");
            this.errorMessageMobileNumber = "";
            this.errorMessageNumericMobileNumber = "";
          }
        },
        (error) => {
          this.toastr.error("Server Error");
          this.errorMessageMobileNumber = "";
          this.errorMessageNumericMobileNumber = "";
        }
      );
    } else if (
      this.reset.mobileNumber == null ||
      this.reset.mobileNumber == undefined ||
      this.reset.mobileNumber == ""
    ) {
      this.errorMessageMobileNumber = "Please enter valid User Name.";
      this.errorMessageNumericMobileNumber = "";
    }
  }

  keyPressMobileNumber(event: any) {
    const pattern = /^\S/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && event.keyCode != 8 && event.keyCode != 13) {
      this.errorMessageNumericMobileNumber = "Enter only numbers";
      this.errorMessageMobileNumber = "";
      event.preventDefault();
    } else {
      this.errorMessageNumericMobileNumber = "";
      this.errorMessageMobileNumber = "";
    }
  }

  keyPressOTPNumber(event: any) {
    const pattern = /[0-9{4}]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && event.keyCode != 8 && event.keyCode != 13) {
      this.errorMessageNumericOTP = "Enter only numbers";
      this.errorMessageOTP = "";
      event.preventDefault();
    } else {
      this.errorMessageNumericOTP = "";
      this.errorMessageOTP = "";
    }
  }

  resetPassword(number: string, otp: string) {
    if (
      this.reset.otp != null &&
      this.reset.otp != undefined &&
      this.reset.otp != ""
    ) {
      this.forgotPasswordService.resetPassword(number, otp).subscribe(
        (response) => {
          this.otpResult = JSON.parse(JSON.stringify(response));
          if (this.otpResult != undefined && this.otpResult.Status != false) {
            this.toastr.success(
              this.otpResult.SuccessMessage,
              "Reset Password"
            );
            this.errorMessageNumericOTP = "";
            this.errorMessageOTP = "";
            localStorage.setItem("resetMobile", this.reset.mobileNumber);
            this.resetModalOpen = true;
            this.forgotPasswordModalOpen = false;
            // this.router.navigate(['/resetPassword']);
          } else if (this.otpResult.Status != true) {
            this.toastr.error(this.otpResult.ErrorMessage, "Reset Password");
            this.hideMobileNumber = false;
            this.hideOtpNumber = true;
            this.errorMessageNumericOTP = "";
            this.errorMessageOTP = "";
          }
        },
        (error) => {
          this.toastr.error("Server Error");
          this.errorMessageNumericOTP = "";
          this.errorMessageOTP = "";
        }
      );
    } else if (
      this.reset.otp == null ||
      this.reset.otp == undefined ||
      this.reset.otp == ""
    ) {
      this.errorMessageOTP = "Please enter valid OTP";
      this.errorMessageNumericOTP = "";
    }
  }
  faqPage() {
    this.router.navigate(["faq"]);
  }
  termsAndConditionsPage() {
    this.router.navigate(["termsandconditions"]);
  }

  // Reset Password
  hideResetPasswordModal(form: NgForm) {
    this.forgotPasswordModalOpen = false;
    this.resetModalOpen = false;
    form.resetForm();
    window.location.reload();
  }

  updatePassword() {
    this.resetModalOpen = true;
    this.errorMessageNewPassword = "";

    let emailPattern = this.reset.NewPassword;
    const pattern =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#_])[A-Za-z\d@$!%*#_]{8,16}$/;
    if (!pattern.test(emailPattern)) {
      this.errorMessageNewPassword = "Enter valid password";
      return;
    }
    if (this.reset.NewPassword == this.reset.ConfirmNewPassword) {
      var tempMob = localStorage.getItem("resetMobile");
      this.reset.mobileNumber = tempMob;
      this.changePassService.updatePassword(this.reset).subscribe((data) => {
        // debugger
        this.apiModel = JSON.parse(JSON.stringify(data));
        if (this.apiModel.Status != false) {
          //this.toastr.success(this.apiModel.SuccessMessage, 'Reset Password');

          //window.location.reload();
          this.router.navigate(["/pre-login"]);
          this.resetModalOpen = false;
          this.loginModalOpen = true;
          this.toastr.success(this.apiModel.SuccessMessage, "Reset Password");
        } else {
          this.toastr.error(this.apiModel.ErrorMessage, "Reset Password");
          this.errorMessageNewPassword = "";
          this.errorMessageConfirmPassword = "";
        }
      });
    }
  }
  ScrollToRegister(el) {
    this.router.navigate(["/pre-login"]);
    el.scrollIntoView();
  }
  preLoginHome(menuId) {
    window.scrollTo(0, 0);
    this.onPreLoginMenuOptionClick.emit(menuId);
  }
  preLoginMenuOption(menuId) {
    this.onPreLoginMenuOptionClick.emit(menuId);
  }

  clearValidation() {
    if (this.reset.NewPassword == this.reset.ConfirmNewPassword) {
      this.errorMessageConfirmPassword = "";
    } else {
      this.errorMessageConfirmPassword = "Password does not match";
    }
  }

  showUnlockModal() {
    this.unlockModalOpen = true;
    this.unlock = { userName: "", mobileNumber: "", otp: "" };
    this.unlockOtpStep = false;
    this.loginModalOpen = false;
  }

  hideUnlockModal(form?: NgForm) {
    this.unlockModalOpen = false;
    this.unlockOtpStep = false;
    this.unlock = { userName: "", mobileNumber: "", otp: "" };
    this.unlockErrorMessage = "";
    if (form) form.resetForm();
  }

  closeAndReloadUnlockModal(form?: NgForm) {
    this.hideUnlockModal(form);
    window.location.reload();
  }

  hideUnlockSuccessModal() {
    this.unlockSuccessModalOpen = false;
    this.CustomerModalOpen = false;
  }

  showLoginFromUnlockSuccess() {
    this.unlockSuccessModalOpen = false;
    this.loginModalOpen = true;
    this.CustomerModalOpen = true;
  }

  unlockInitial() {
    this.unlockErrorMessage = "";
    if (!this.unlock.userName) {
      this.unlockErrorMessage = "Please enter valid username.";
      return;
    }

    // Step 1: Initial Unlock
    this.unlockUserService.unlockUser(this.unlock.userName, true).subscribe(
      (res) => {
        if (res.responseCode === 0 && res.data && res.data.mobileNumber) {
          this.unlock.mobileNumber = res.data.mobileNumber; // Store mobile number

          // Step 2: Send OTP
          this.unlockUserService.sendOtp(this.unlock.mobileNumber).subscribe(
            (otpRes) => {
              if (otpRes.responseCode === 0) {
                this.toastr.success("OTP Sent Successfully", "OTP");
                this.unlockOtpStep = true;
              } else {
                this.toastr.error(
                  otpRes.responseMessage || "Failed to send OTP",
                  "OTP"
                );
              }
            },
            () => this.toastr.error("Server error while sending OTP")
          );
        } else if (res.responseCode === 9998) {
          this.toastr.warning(res.responseMessage);
        } else {
          this.toastr.error(
            res.responseMessage || "Invalid Username or User Locked"
          );
        }
      },
      () => this.toastr.error("Server error while unlocking user")
    );
  }

  verifyUnlockOtp() {
    this.unlockErrorMessage = "";
    if (!this.unlock.otp) {
      this.unlockErrorMessage = "Please enter OTP.";
      return;
    }

    // Step 3: Verify OTP
    this.unlockUserService
      .verifyOtp(this.unlock.mobileNumber, this.unlock.otp)
      .subscribe((verifyRes) => {
        if (verifyRes.responseCode === 0) {
          // OTP is correct
          // Step 4: Final Unlock
          this.unlockUserService
            .unlockUser(this.unlock.userName, false)
            .subscribe((finalRes) => {
              if (finalRes.responseCode === 0) {
                this.hideUnlockModal(); // Close unlock modal
                this.unlockSuccessMessage =
                  "Your account has been successfully unlocked. Please login.";
                this.unlockSuccessModalOpen = true;
              } else {
                this.toastr.error(
                  finalRes.responseMessage || "Failed to unlock account"
                );
              }
            });
        } else {
          this.toastr.error(verifyRes.responseMessage || "Invalid OTP");
        }
      });
  }

  resendUnlockOtp() {
    if (!this.unlock.mobileNumber) {
      this.toastr.error("Mobile number not available. Please start over.");
      return;
    }
    this.unlockUserService.sendOtp(this.unlock.mobileNumber).subscribe(
      (otpRes) => {
        if (otpRes.responseCode === 0) {
          this.toastr.success("OTP has been resent successfully", "OTP");
        } else {
          this.toastr.error(
            otpRes.responseMessage || "Failed to resend OTP",
            "OTP"
          );
        }
      },
      () => this.toastr.error("Server error while resending OTP")
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/pre-login-header/pre-login-header.component.ts